import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { ColumnWidthInfo } from "../../../common/services/crudServices";
import { useRootStore } from "../../../../store/contexts";
import { ShowReference } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { ShowItemsCompact } from "../../../common/controls";
import { CrudRows } from "../../../common/types";
import { GridColumn } from "../../../common/types";
import { FormControl } from "@mui/material";

export type WorkAuthorViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  authorValue: { displayId: string; id: string } | null;
  viewFormAuthor?: () => void;
  lyricsPercentageValue?: { displayId: string; id: string } | null;
  lyricsPercentage: number;
  musicPercentageValue?: { displayId: string; id: string } | null;
  musicPercentage: number;
  publishersRows: CrudRows;
  publishersVisibleColumns: GridColumn[];
  publishersSetColumnWiths: (x: ColumnWidthInfo[]) => void;
};

export const WorkAuthorViewForm: React.FC<WorkAuthorViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    authorValue,
    viewFormAuthor = () => {},
    lyricsPercentage = 0,
    musicPercentage = 0,
    publishersRows,
    publishersVisibleColumns,
    publishersSetColumnWiths,
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupWorkAuthorLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <ShowReference
                label={langStore.WorkAuthorAuthorLabel}
                selectedValue={langStore.displayIdByLang(
                  authorValue?.displayId
                )}
                onView={viewFormAuthor}
              />
              <ShowNumber
                value={lyricsPercentage}
                label={langStore.WorkAuthorLyricsPercentageLabel}
                decimalScale={2}
              />
              <ShowNumber
                value={musicPercentage}
                label={langStore.WorkAuthorMusicPercentageLabel}
                decimalScale={2}
              />
              <ShowItemsCompact
                rows={publishersRows}
                showLabel={true}
                label={langStore.WorkAuthorPublishersLabel}
                columns={publishersVisibleColumns}
                setColumnWidths={publishersSetColumnWiths}
                entityName="WorkAuthorPublisher"
                enableDownload={true}
                onRowClick={(rowId) =>
                  rootStore.openSubentityModal("workAuthorPublisher", rowId)
                }
              />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
